import React, { FC, useMemo } from 'react'

import { Toggle } from '@style-port/roov-ui-components-react'
import { Tooltip, Txt } from 'src/components/atoms'

import { useError, useGlobalLoading, useCompanyAuthMethod, useToast } from 'src/hooks'
import { CompanyEntity } from 'src/types'

type Props = {
  company: CompanyEntity
  hasAllRequiredInput: boolean
  afterUpdate: () => void
  className?: string
}

export const SamlAuthToggle: FC<Props> = ({
  company,
  hasAllRequiredInput,
  afterUpdate,
  className,
}) => {
  const { showGlobalLoading, hideGlobalLoading } = useGlobalLoading()
  const { updateCompanyAuthMethod } = useCompanyAuthMethod()
  const { toErrorEntities } = useError()
  const { displayStandardTextToast, displayErrorTextToast } = useToast()

  const handleOnChange = async (isNewValue: boolean) => {
    showGlobalLoading()
    try {
      await updateCompanyAuthMethod(company.id, {
        isIDPassEnabled: company.isIDPassEnabled,
        isSAMLEnabled: isNewValue,
      })
      displayStandardTextToast('SAML認証を更新しました')
      afterUpdate()
    } catch (error) {
      const errors = toErrorEntities(error)
      console.log('errors: ', errors)
      displayErrorTextToast('SAML認証の更新に失敗しました')
    } finally {
      hideGlobalLoading()
    }
  }

  const isDisabledToggle = useMemo(
    () => (!company.isIDPassEnabled && company.isSAMLEnabled) || !hasAllRequiredInput,
    [company.isIDPassEnabled, company.isSAMLEnabled, hasAllRequiredInput]
  )

  return (
    <div className={className}>
      <div className="tw-centering">
        <Txt className="tw-mr-s-1 tw-font-bold tw-text-roovPrimary-default">SAML認証</Txt>
        <Tooltip
          text={
            hasAllRequiredInput
              ? 'パスワードでのログイン、SAML認証どちらかは有効にする必要があります'
              : 'メタデータソース形式を登録後選択出来ます'
          }
          showIcon={false}
          disabled={!isDisabledToggle}
        >
          <Toggle
            enabled={company.isSAMLEnabled}
            onChange={handleOnChange}
            disabled={isDisabledToggle}
          />
        </Tooltip>
      </div>
    </div>
  )
}
